import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { IcTags, IcPlus, IcEdit } from "../../../Icons";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";

function ListadoConceptosGastos() {
  const { user } = useContext(AuthContext);
  const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const URL_LOGS              = process.env.REACT_APP_URL_LOGS;

  const [conceptosGastos, setConceptosGastos] = useState([]);

  // ── Edit modal ────────────────────────────────────────────────────────────
  const [modal,  setModal]  = useState(false);
  const toggle              = () => setModal(!modal);
  const [idEdit, setIdEdit] = useState("");
  const [name,   setName]   = useState("");

  // ── Create modal ──────────────────────────────────────────────────────────
  const [modalCreate,   setModalCreate]   = useState(false);
  const toggleCreate                      = () => setModalCreate(!modalCreate);
  const [nameNew,       setNameNew]       = useState("");
  const [validaBoton,   setValidaBoton]   = useState(true);

  useEffect(() => {
    axios
      .get(URL_CONCEPTOS_GASTOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => setConceptosGastos(response.data))
      .catch(() => {});
  }, []);

  // ── Create ────────────────────────────────────────────────────────────────
  function saveConceptosGastos(event) {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(URL_CONCEPTOS_GASTOS, { name: nameNew }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then(() => {
        axios.post(URL_LOGS, { tipo: "Crear Concepto Gastos", detalle: nameNew, user: user.id }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        setNameNew("");
        setValidaBoton(true);
        toggleCreate();
        Swal.fire("¡Listo!", "Concepto creado con éxito", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data}`,
        });
        setValidaBoton(true);
      });
  }

  // ── Edit ──────────────────────────────────────────────────────────────────
  function editConcepto(event) {
    event.preventDefault();
    axios
      .patch(`${URL_CONCEPTOS_GASTOS}/${idEdit}`, { name }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then(() => {
        axios.post(URL_LOGS, { tipo: "Editar Concepto", detalle: name, user: user.id }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        toggle();
        Swal.fire("¡Listo!", "Actualizado con éxito", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data}`,
        });
      });
  }

  function jalaInfo(idEdit, name) {
    setName(name);
    setIdEdit(idEdit);
    toggle();
  }

  return (
    <>
      <Header />
      {user.menu_gastos ? (
        <div className="card container col-sm-6">

          {/* ── Page header ──────────────────────────────────────────────── */}
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcTags style={{ marginRight: 8, color: "#f59e0b" }} />
                Conceptos de Gastos
              </h3>
              <p className="page-subtitle">Catálogo de conceptos para clasificar gastos</p>
            </div>
            <div className="page-actions">
              <Button color="success" size="sm" onClick={toggleCreate}>
                <IcPlus style={{ marginRight: 6 }} />
                Nuevo Concepto
              </Button>
            </div>
          </div>

          {/* ── Tabla ────────────────────────────────────────────────────── */}
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Editar</th>
              </tr>
            </thead>
            <tbody>
              {conceptosGastos
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => (
                  <tr key={a._id}>
                    <td>{a.name}</td>
                    <td>
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => jalaInfo(a._id, a.name)}
                      >
                        <IcEdit />
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      ) : undefined}

      {/* ── Modal: Nuevo Concepto ─────────────────────────────────────────── */}
      <Modal size="sm" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <IcPlus style={{ marginRight: 8, color: "#10b981" }} />
          Nuevo Concepto de Gasto
        </ModalHeader>
        <ModalBody>
          <Label>Concepto</Label>
          <Input
            type="text"
            placeholder="Nombre del concepto"
            value={nameNew}
            required
            onChange={(e) => setNameNew(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveConceptosGastos} disabled={!validaBoton}>
            Guardar
          </Button>
          <Button color="secondary" onClick={toggleCreate}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* ── Modal: Editar Concepto ────────────────────────────────────────── */}
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <IcEdit style={{ marginRight: 8, color: "#3b82f6" }} />
          Editar Concepto de Gasto
        </ModalHeader>
        <ModalBody>
          <Label>Nombre</Label>
          <Input
            type="text"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editConcepto}>
            Guardar
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoConceptosGastos;
